module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cvi.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/als.htm",
      "id": "als"
    }
  }, [_vm._v("Also by Mark Billingham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ded.htm"
    }
  }, [_vm._v("Dedication")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm",
      "id": "pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm#pro1",
      "id": "pro1"
    }
  }, [_vm._v("Florida")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm",
      "id": "p01"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm#p01",
      "id": "p01x"
    }
  }, [_vm._v("Angie and Barry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm",
      "id": "c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm",
      "id": "c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm",
      "id": "c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm",
      "id": "c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm",
      "id": "c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm",
      "id": "c06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm",
      "id": "c07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm",
      "id": "c08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm",
      "id": "c09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm",
      "id": "c10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm",
      "id": "c11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm",
      "id": "c12"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm",
      "id": "c13"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm",
      "id": "c14"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01a.htm",
      "id": "p01a"
    }
  }, [_vm._v("The First Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm",
      "id": "c15"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c16.htm",
      "id": "c16"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c17.htm",
      "id": "c17"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c18.htm",
      "id": "c18"
    }
  }, [_vm._v("Chapter Eighteen")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02.htm",
      "id": "p02"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02.htm#p02",
      "id": "p02x"
    }
  }, [_vm._v("Sue and Ed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c19.htm",
      "id": "c19"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c20.htm",
      "id": "c20"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c21.htm",
      "id": "c21"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c22.htm",
      "id": "c22"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c23.htm",
      "id": "c23"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c24.htm",
      "id": "c24"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c25.htm",
      "id": "c25"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c26.htm",
      "id": "c26"
    }
  }, [_vm._v("Chapter Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c27.htm",
      "id": "c27"
    }
  }, [_vm._v("Chapter Twenty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c28.htm",
      "id": "c28"
    }
  }, [_vm._v("Chapter Twenty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c29.htm",
      "id": "c29"
    }
  }, [_vm._v("Chapter Twenty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c30.htm",
      "id": "c30"
    }
  }, [_vm._v("Chapter Thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c31.htm",
      "id": "c31"
    }
  }, [_vm._v("Chapter Thirty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c32.htm",
      "id": "c32"
    }
  }, [_vm._v("Chapter Thirty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c33.htm",
      "id": "c33"
    }
  }, [_vm._v("Chapter Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c34.htm",
      "id": "c34"
    }
  }, [_vm._v("Chapter Thirty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c35.htm",
      "id": "c35"
    }
  }, [_vm._v("Chapter Thirty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c36.htm",
      "id": "c36"
    }
  }, [_vm._v("Chapter Thirty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c37.htm",
      "id": "c37"
    }
  }, [_vm._v("Chapter Thirty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02a.htm",
      "id": "p02a"
    }
  }, [_vm._v("The Second Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c38.htm",
      "id": "c38"
    }
  }, [_vm._v("Chapter Thirty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c39.htm",
      "id": "c39"
    }
  }, [_vm._v("Chapter Thirty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c40.htm",
      "id": "c40"
    }
  }, [_vm._v("Chapter Forty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c41.htm",
      "id": "c41"
    }
  }, [_vm._v("Chapter Forty-One")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03.htm",
      "id": "p03"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03.htm#p03",
      "id": "p03x"
    }
  }, [_vm._v("Marina and Dave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c42.htm",
      "id": "c42"
    }
  }, [_vm._v("Chapter Forty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c43.htm",
      "id": "c43"
    }
  }, [_vm._v("Chapter Forty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c44.htm",
      "id": "c44"
    }
  }, [_vm._v("Chapter Forty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c45.htm",
      "id": "c45"
    }
  }, [_vm._v("Chapter Forty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c46.htm",
      "id": "c46"
    }
  }, [_vm._v("Chapter Forty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c47.htm",
      "id": "c47"
    }
  }, [_vm._v("Chapter Forty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c48.htm",
      "id": "c48"
    }
  }, [_vm._v("Chapter Forty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c49.htm",
      "id": "c49"
    }
  }, [_vm._v("Chapter Forty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c50.htm",
      "id": "c50"
    }
  }, [_vm._v("Chapter Fifty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c51.htm",
      "id": "c51"
    }
  }, [_vm._v("Chapter Fifty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c52.htm",
      "id": "c52"
    }
  }, [_vm._v("Chapter Fifty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c53.htm",
      "id": "c53"
    }
  }, [_vm._v("Chapter Fifty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c54.htm",
      "id": "c54"
    }
  }, [_vm._v("Chapter Fifty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c55.htm",
      "id": "c55"
    }
  }, [_vm._v("Chapter Fifty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c56.htm",
      "id": "c56"
    }
  }, [_vm._v("Chapter Fifty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c57.htm",
      "id": "c57"
    }
  }, [_vm._v("Chapter Fifty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03a.htm",
      "id": "p03a"
    }
  }, [_vm._v("The Final Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c58.htm",
      "id": "c58"
    }
  }, [_vm._v("Chapter Fifty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c59.htm",
      "id": "c59"
    }
  }, [_vm._v("Chapter Fifty-Nine")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04.htm",
      "id": "p04"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04.htm",
      "id": "p04x"
    }
  }, [_vm._v("Sue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c60.htm",
      "id": "c60"
    }
  }, [_vm._v("Chapter Sixty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c61.htm",
      "id": "c61"
    }
  }, [_vm._v("Chapter Sixty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c62.htm",
      "id": "c62"
    }
  }, [_vm._v("Chapter Sixty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c63.htm",
      "id": "c63"
    }
  }, [_vm._v("Chapter Sixty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c64.htm",
      "id": "c64"
    }
  }, [_vm._v("Chapter Sixty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c65.htm",
      "id": "c65"
    }
  }, [_vm._v("Chapter Sixty-Five")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/MB/MBturn",
      "id": "TEA"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Murder Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 75
// module chunks = 0